<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Pipelines</h1>

                    <a :href="`/#/admin/integrations/pipelines/create/${organiationUnitId}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        <span>Create pipeline</span>
                    </a>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <div class="card-group">
                <div class="card bg-light">
                    <div class="card-body">
                        <h5 class="card-title">Pipelines</h5>
                        <p class="card-text">Browse and manage your pipelines to import or export data.</p>
                        <a :href="`/#/admin/integrations/pipelines/manage/${organiationUnitId}`" class="btn btn-primary">All pipelines</a>
                    </div>
                    <!--<div class="card-footer">
                        <small>6 active | 2 recent</small>
                    </div>-->
                </div>

                <div class="card bg-light">
                    <div class="card-body">
                        <h5 class="card-title">Connectors</h5>
                        <p class="card-text">See and manage connectors that are used to read from or write to them data from datasets.</p>
                        <a :href="`/#/admin/integrations/connectors/manage/${organiationUnitId}`" class="btn btn-primary">All connectors</a>
                    </div>
                    <!--<div class="card-footer">
                        <small>27 runs today | Last: Pipeline1</small>
                    </div>-->
                </div>

                <div class="card bg-light">
                    <div class="card-body">
                        <h5 class="card-title">Datasets</h5>
                        <p class="card-text">Datasets are storing data for pipelines. Can be shared or pipline scoped</p>
                        <a :href="`/#/admin/integrations/datasets/manage/${organiationUnitId}`" class="btn btn-primary">All datasets</a>
                    </div>
                    <!--<div class="card-footer">
                        <small>12 datasets | 3 shared</small>
                    </div>-->
                </div>
            </div>
            <br />

            <div class="d-flex w-100 justify-content-between">
                <h4>Last runs</h4>
                <a :href="`/#/admin/integrations/runs/manage/${organiationUnitId}`">See all runs</a>
            </div>

            <div class="list-group">
                <a v-for="r in lastRuns" :key="r.RunId"
                   :href="`/#/admin/integrations/runs/details/${organiationUnitId}/${r.RunId}`"
                   class="list-group-item list-group-item-action"
                   :class="{'list-group-item-secondary': r.Queued, 'list-group-item-primary': r.Running, 'list-group-item-success': r.Succeed, 'list-group-item-danger': (r.Failed || r.Aborted) && !r.Succeed}">
                    <div class="d-flex w-100 justify-content-between">
                        <h6 class="mb-1">
                            <span v-if="r.Running">[Running]</span>
                            <span v-else-if="r.Succeed">[Succeed]</span>
                            <span v-else-if="r.Failed">[Failed({{r.FailuresCount}})]</span>
                            <span v-else-if="r.Aborted">[Aborted]</span>
                            <span v-else>[Queued]</span>
                            <span>{{r.PipelineName}}111</span>
                        </h6>
                        <small>
                            <span>{{r.LastActivityAtSinceNow}} ago</span>
                        </small>
                    </div>
                    <p class="mb-1">
                        {{r.Trigger}}
                        <span v-if="r.QueuedByName">by {{r.QueuedByName}}</span>
                        <span>{{r.QueuedAtSinceNow}} ago</span>
                        <span v-if="r.StartedAtSinceNow">/ started {{r.StartedAtSinceNow}} ago</span>
                        <span v-if="r.CompletedAtSinceNow">/ completed {{r.CompletedAtSinceNow}} ago</span>
                        <span v-if="r.FailedAtSinceNow">/ failed {{r.FailedAtSinceNow}} ago</span>
                        <span v-if="r.AbortedAtSinceNow">/ aborted {{r.AbortedAtSinceNow}} ago</span>
                    </p>
                </a>
            </div>
            <br /><br />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, onMounted, watch } from 'vue'
    import { usePageReloaded, useOrganizationUnitId } from '@common/composables'
    import { useAdminPipelinesDashboardPage } from '@Integrations/Pipelines/pages-core'

    document.title = "Manage pipelines"

    const reloaded = usePageReloaded()
    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, usePipelinesDashboardQuery, useLastRunsQuery } = useAdminPipelinesDashboardPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelPipelinesDashboardQueryV1, runPipelinesDashboardQueryV1 } = usePipelinesDashboardQuery(tid)
    const organiationUnitId = computed(() => modelPipelinesDashboardQueryV1.value?.OrganizationUnitId)
    
    const { modelLastRunsQueryV1, runLastRunsQueryV1 } = useLastRunsQuery(organiationUnitId, reloaded)
    const lastRuns = computed(() => modelLastRunsQueryV1.value?.Runs || [])

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelinesDashboardQueryV1()
    })

    watch(organiationUnitId, () => runLastRunsQueryV1())
</script>